module.exports = __webpack_public_path__ + "img/piattaformaarancione.7f303131.png";